import React from 'react';

function MsgIcon() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.00002" cy="8.50002" r="2.33333" stroke="#007AFF" strokeWidth="1.2" />
      <path
        d="M6.99998 2.41066C7.61878 2.0534 8.38118 2.0534 8.99998 2.41066L12.7735 4.5893C13.3923 4.94656 13.7735 5.60682 13.7735 6.32135V10.6786C13.7735 11.3931 13.3923 12.0534 12.7735 12.4107L8.99998 14.5893C8.38118 14.9466 7.61878 14.9466 6.99998 14.5893L3.22648 12.4107C2.60767 12.0534 2.22648 11.3931 2.22648 10.6786V6.32135C2.22648 5.60681 2.60767 4.94656 3.22648 4.5893L6.99998 2.41066Z"
        stroke="#007AFF"
        strokeWidth="1.2"
      />
    </svg>
  );
}

function CloseSubIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_b_17566_5510)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
          fill="black"
          fillOpacity="0.45"
        />
      </g>
      <path d="M5.42857 5L10.5714 11" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M10.5714 5L5.42857 11" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
      <defs>
        <filter
          id="filter0_b_17566_5510"
          x="-4"
          y="-4"
          width="24"
          height="24"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_17566_5510" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_17566_5510" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

function CloseModelInfo() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.55719 5.55719C8.00654 3.10784 11.5723 2 16 2C20.4277 2 23.9935 3.10784 26.4428 5.55719C28.8922 8.00654 30 11.5723 30 16C30 20.4277 28.8922 23.9935 26.4428 26.4428C23.9935 28.8922 20.4277 30 16 30C11.5723 30 8.00654 28.8922 5.55719 26.4428C3.10784 23.9935 2 20.4277 2 16C2 11.5723 3.10784 8.00654 5.55719 5.55719ZM18.6667 9.66667C18.6667 10.5871 17.9205 11.3333 17 11.3333C16.0795 11.3333 15.3333 10.5871 15.3333 9.66667C15.3333 8.74619 16.0795 8 17 8C17.9205 8 18.6667 8.74619 18.6667 9.66667ZM16.99 12.7065C17.7044 12.8851 18.1388 13.609 17.9602 14.3234L16.7483 19.1708L17.2929 18.6262C17.6834 18.2357 18.3166 18.2357 18.7071 18.6262C19.0976 19.0168 19.0976 19.6499 18.7071 20.0404L16.0404 22.7071C15.9093 22.8382 15.7509 22.9253 15.5834 22.9684C15.2638 23.2704 14.8016 23.4081 14.3433 23.2935C13.6289 23.1149 13.1945 22.391 13.3731 21.6766L14.8717 15.6822L13.7804 16.2278C13.2865 16.4748 12.6858 16.2746 12.4388 15.7806C12.1918 15.2866 12.392 14.686 12.886 14.439L15.5527 13.1056C15.617 13.0735 15.683 13.0489 15.7499 13.0316C16.0696 12.7296 16.5318 12.5919 16.99 12.7065Z"
        fill="#007AFF"
      />
    </svg>
  );
}

function SearchMsgIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_16760_2554)">
        <circle cx="7.62977" cy="7.62977" r="5.55556" stroke="#565657" strokeWidth="1.2" />
        <path d="M11.7578 11.7578L13.9258 13.9258" stroke="#565657" strokeWidth="1.2" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_16760_2554">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export { MsgIcon, CloseSubIcon, CloseModelInfo, SearchMsgIcon };
